const { DefaultEventTypes } = require('./default');

const UnsubscribeEvents = {
  ATTEMPTED: `unsubscribe.${DefaultEventTypes.ATTEMPTED}`,
  SUCCESS: `unsubscribe.${DefaultEventTypes.SUCCESS}`,
};

module.exports = { UnsubscribeEvents };
